import axiosInstance from '@/services/axiosConfig'

const endPoint = {
	getList: instId => `/institute/${instId}/inventory/list`,
	getHistory: instId => `/institute/${instId}/inventory/log`,
	getHistoryFilter: instId => `/institute/${instId}/inventory/log/filter`,
	deleteHistory: instId => `/institute/${instId}/inventory/log`,
	getInventoryDetail: instId => `/institute/${instId}/inventory`,
	deleteInventoryItem: instId => `/institute/${instId}/inventory`,
	processInventoryItem: instId =>
		`/institute/${instId}/inventory/inventory/register`,
	getFilter: instId => `/institute/${instId}/inventory/list/filter`,
	exportExcel: instId => `/institute/${instId}/inventory/list/export/excel`,
	editInventory: instId => `/institute/${instId}/inventory`,
	getGhsPreview: instId => `/institute/${instId}/safety/ghs/preview`,
	exportGhsQrPdf: instId => `/institute/${instId}/safety/ghs/export/pdf`,
	tagList: instId => `/institute/${instId}/tag/list`,
	favorite: instId => `/institute/${instId}/inventory/favorite`,
	comment: instId => `/institute/${instId}/inventory/comment`,
}

const inventoryAPI = {
	getList: (instId, params) =>
		axiosInstance.get(endPoint.getList(instId), {
			params: params,
		}),
	getHistory: (instId, params) =>
		axiosInstance.get(endPoint.getHistory(instId), { params }),
	getHistoryFilter: (instId, params) =>
		axiosInstance.get(endPoint.getHistoryFilter(instId), { params }),
	deleteHistory: (instId, params) =>
		axiosInstance.delete(endPoint.deleteHistory(instId), { params }),
	registInventory: (instId, formData) =>
		axiosInstance.post(endPoint.registInventory(instId), formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}),
	divideInventoryItem: (instId, body) =>
		axiosInstance.patch(endPoint.divideInventoryItem(instId), body),
	getInventoryDetail: (instId, params) =>
		axiosInstance.get(endPoint.getInventoryDetail(instId), {
			params: params,
		}),
	deleteInventoryItem: (instId, body) =>
		axiosInstance.delete(endPoint.deleteInventoryItem(instId), {
			params: body,
		}),
	processInventoryItem: (instId, body) =>
		axiosInstance.post(endPoint.processInventoryItem(instId), body),
	getFilter: (instId, params) =>
		axiosInstance.get(endPoint.getFilter(instId), {
			params,
		}),
	editInventory: (instId, formData) =>
		axiosInstance.put(endPoint.editInventory(instId), formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}),
	tagList: (instId, params) =>
		axiosInstance.get(endPoint.tagList(instId), { params }),
	addFavorite: (instId, params) =>
		axiosInstance.post(endPoint.favorite(instId), params),
	deleteFavorite: (instId, params) =>
		axiosInstance.delete(endPoint.favorite(instId), { params }),
	getComment: (instId, params) =>
		axiosInstance.get(endPoint.comment(instId), { params }),
	addComment: (instId, body) =>
		axiosInstance.post(endPoint.comment(instId), body),
	deleteComment: (instId, params) =>
		axiosInstance.delete(endPoint.comment(instId), { params }),
}

export default inventoryAPI
